/**
 * Tuijncode Invoice Download Formatter.
 */
window.tuijncodeInvoiceDownloadFormatter = function(value, row) {
    let html = '';
    if (row.hash_name) {
        html += '<a href="/tuijncode/invoices/download/'+row.invoice_id+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
}
